"use strict";

jQuery( function ($) {
    

    function moveTrainingSidebar() {
        var $sidebar = false;
    
        if ($('.wpg-wdp-productform-sidebar').length) {
            $sidebar = $('.wpg-wdp-productform-sidebar');

            $('.wpg-wdp-productform-sidebar-price-header').html('Totaalbedrag');
        }

        if (!$sidebar || !$("form.iforms").length) {
            return false;
        }

        if ($(".field__wrapper--totaalbedrag").length) {
            $sidebar.clone().addClass('sidebar-in-iform sidebar-in-iform-payment').insertBefore( ".field__wrapper--totaalbedrag" );
        } else {
            $sidebar.clone().addClass('sidebar-in-iform').prependTo( "form.iforms" );
        }
    }

    function setMinimalHeaderBackbuttonUrl() {
        var $first_step = $('.wpg-wdp-productform .iform_pages_list .list-group-item:first-child');

        if ($first_step.length && !$first_step.hasClass('active')) {
            var back_url = $first_step.find('a').attr("href");

            if (back_url.length && $('a.header-minimal-back').length) {
                $('a.header-minimal-back').attr("href", back_url);
            }
        }
    }

    moveTrainingSidebar();
    setMinimalHeaderBackbuttonUrl();

    $( 'body' ).on( 'iform_initialized', function() {
        moveTrainingSidebar();
        setMinimalHeaderBackbuttonUrl();
    } );
});

